import {urlParams} from 'utils/urlParams'
import {UserParametersContext} from '@daedalus/core/src/analytics/types/Events'
import {getWindowSize} from '@daedalus/core/src/utils/window/getWindowSize'

const getUserParametersContext = (): UserParametersContext => {
  const {deviceType, userCountry} = urlParams()
  const {width: viewPortWidth, height: viewPortHeight} = getWindowSize()

  return {deviceType, userCountry, viewPortWidth, viewPortHeight}
}

export default getUserParametersContext
